import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const options = [
  { value: "1", label: "Beginner" },
  { value: "2", label: "Intermediate" },
  { value: "3", label: "Fluent" },
  { value: "4", label: "Native" },
];

export default function EAddLanguage({
  formData,
  setFormData,
  nextPage,
  previousPage,
}) {
  const [validation, setValidation] = useState(false);
  const [allLanguage, setAllLanguage] = useState("");
  const [optionsss, setOptionsss] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedLanguages, setSelectedLanguages] = useState(
    formData.language || [],
  );
  const languagelist = useSelector(
    ({ categary: { languagelist } }) => languagelist,
  );
  const proficiencylist = useSelector(
    ({ categary: { proficiencylist } }) => proficiencylist,
  );

  useEffect(() => {
    setAllLanguage(languagelist);
  }, [languagelist]);

  useEffect(() => {
    setOptionsss(proficiencylist);
  }, [proficiencylist]);

  const handleLanguageChange = (selectedOption) => {
    setSelectedLanguage(selectedOption);
    const newLanguage = {
      language_id: selectedOption.value,
      proficiency_id: "",
      language_title: selectedOption.label,
      proficiency_title: "",
    };
    setSelectedLanguages([...selectedLanguages, newLanguage]);
    setSelectedLanguage(null);
  };

  const handleProficiencyChange = (selectedOption, index) => {
    const updatedLanguages = [...selectedLanguages];
    updatedLanguages[index].proficiency_id = selectedOption.value;
    updatedLanguages[index].proficiency_title = selectedOption.label;
    setSelectedLanguages(updatedLanguages);
    setFormData((prevData) => ({
      ...prevData,
      language: updatedLanguages,
      language_title: updatedLanguages.label,
    }));
  };

  const handleDeleteLanguage = (languageId) => {
    const updatedLanguages = selectedLanguages.filter(
      (language) => language.language_id !== languageId,
    );
    setSelectedLanguages(updatedLanguages);
    setFormData((prevData) => ({
      ...prevData,
      language: updatedLanguages,
      language_title: updatedLanguages.label,
    }));
  };
  const SubmitandNext = () => {
    if (formData.language?.length > 0) {
      nextPage();
    } else {
      setValidation(true);
    }
  };
  useEffect(() => {
    if (formData.language) {
      setValidation(false);
    }
  }, [formData.language]);

  return (
    <div>
      <div className="row about-row">
        <div className="col-md-12 about-right">
          <div className="skill-sec">
            <h6>Add your language  <AsteriskLabel /></h6>
            <div className="skill-img">
              <button className="btn skill-img-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/select-icon.svg`}
                  alt=""
                />
              </button>
              <ReactSelect
                options={
                  Array.isArray(allLanguage) &&
                  allLanguage
                    .filter(
                      (lang) =>
                        !selectedLanguages.some(
                          (selectedLang) =>
                            selectedLang.language_id === lang.id,
                        ),
                    )
                    .map((lang) => ({ value: lang.id, label: lang.title }))
                }
                placeholder="Select language"
                isClearable={true}
                value={selectedLanguage}
                onChange={handleLanguageChange}
              />
            </div>
          </div>

          <div>
            {Array.isArray(selectedLanguages) &&
              selectedLanguages.map((language, index) => (
                <div key={index} className="language-sec row">
                  <div className="form-group col-md-5 col-10">
                    <label>{`${index + 1}. Language: `}</label>
                    <input
                      className="w-100"
                      value={
                        Array.isArray(allLanguage) &&
                        allLanguage.find(
                          (lang) => lang.id === language.language_id,
                        )?.title
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group col-md-6 col-10 ">
                    <label className="label">Proficiency</label>
                    <ReactSelect
                      options={
                        Array.isArray(optionsss) &&
                        optionsss.map((val) => ({
                          value: val.id,
                          label: val.title,
                        }))
                      }
                      placeholder="Select Proficiency"
                      value={
                        Array.isArray(optionsss) &&
                        optionsss.find(
                          (val) => val.id === language.proficiency_id,
                        )
                          ? {
                              value: language.proficiency_id,
                              label: optionsss.find(
                                (val) => val.id === language.proficiency_id,
                              ).title,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleProficiencyChange(selectedOption, index)
                      }
                    />
                  </div>

                  <div className="col-md-1 p-0 close-icon-btn"
                    onClick={() => {
                      handleDeleteLanguage(language.language_id);
                    }}
                  >
                    <label className="d-block">&nbsp;</label>
                    <button>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets//Images/expertregisteration/delete-icon.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              ))}
          </div>
          {validation == true && (
            <p style={{ color: "red" }}>
              At Least Add one Language with Proficiency
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
